module.exports = __webpack_public_path__ + "img/20190529142935微信截图_20190529143334.eb21ac92.png";